import RouteUnauthorized from "./RouteUnauthorized";
import RouteAdmin from "./RouteAdmin";

export {
  RouteAdmin,
  RouteUnauthorized
};
